import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import './Navbar.css';

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  // Close menu on route change
  useEffect(() => setIsOpen(false), [location.pathname]);

  const links = [
    { name: 'Home',        path: '/' },
    { name: 'Services',    path: '/services' },
    { name: 'Domain',      path: '/domain' },
    { name: 'Clients',     path: '/clients' },
    { name: 'Capability Statement',  path: '/capability' },
  ];

  return (
    <nav className={`navbar${scrolled ? ' scrolled' : ''}`}>
      <a href="/" className="navbar-logo">
  <img 
    src="/favicon.ico" 
    alt="Softick LLC" 
    className="logo-icon"
  />
  <div className="logo-text-group">
    <span className="logo-wordmark">Softick LLC</span>
    <span className="logo-tagline">Technology Solutions</span>
  </div>
</a>

      <button
        className={`menu-icon${isOpen ? ' open' : ''}`}
        onClick={() => setIsOpen(!isOpen)}
        aria-label="Toggle navigation"
        aria-expanded={isOpen}
      >
        <span />
        <span />
        <span />
      </button>

      <ul className={`nav-links${isOpen ? ' open' : ''}`}>
        {links.map((link) => (
          <li key={link.path}>
            <a
              href={link.path}
              className={location.pathname === link.path ? 'active' : ''}
            >
              {link.name}
            </a>
          </li>
        ))}
        <li className="nav-cta">
          <a href="/contact">Contact Us</a>
        </li>
      </ul>
    </nav>
  );
};

export default Navbar;